export default "__VITE_ASSET__0P4OfAfO__"